<script>
	import { menuItems } from '$lib/config/menu.js';
	import SidebarItem from './SidebarItem.svelte';

	export let onItemClick = () => {};
</script>

<nav class="flex flex-col gap-1 p-4">
	{#each menuItems as item (item.id)}
		<SidebarItem {item} onClick={onItemClick} />
	{/each}
</nav>
